<template>
  <div v-tooltip="'Acciones'">
    <vs-dropdown vs-custom-content vs-trigger-click>
      <a class="a-icon" href.prevent>
        <vs-icon
          icon="more_vertical"
          size="medium"
          bg="#E4E4E4"
          round
          color="gray"
        />
      </a>
      <vs-dropdown-menu>
        <component
          v-for="accion in acciones"
          :key="accion" :is="cargarComponenteAccion(accion)"
          :handle-list="handleList"
          :accion="accion" :documento="documento">
        </component>
      </vs-dropdown-menu>
    </vs-dropdown>
    <b-modal
      :title="getTitulo" v-model="mostrarModal"
      no-close-on-backdrop centered hide-footer
      @keyup.enter.native="mostrarModal = false">
      <component v-if="mostrarModal" :is="getCompomente"></component>
    </b-modal>
    <!-- Popup de Pantalla Completa -->
    <b-modal
      :title="getTitulo" v-model="mostrarModalFull"
      @keyup.enter.native="mostrarModalFull = false"
      no-close-on-backdrop centered hide-footer
      content-class="fullscreen" size="xl"
    >
      <component v-if="mostrarModalFull" :is="getCompomente"></component>
    </b-modal>

  </div>

</template>

<script>
// import AccionesListadoFacturaElectronicaMixin
// from "../mixins/AccionesListadoFacturaElectronicaMixin";
import modalStore from '../../../../store/modals/acciones';

export default {
  name: 'AccionesWrapper',
  props: [
    'acciones',
    'documento',
    'handleList'
  ],
  data() {
    return {
      despliegueDeAcciones: [],
      componentes: {},
    };
  },
  computed: {
    mostrarModal: {
      get() {
        // return modalStore.state.showModal;
        // eslint-disable-next-line
        return modalStore.state.showModal && modalStore.state.febosId == this.documento.febosId;
      },
      set() {
        if (modalStore.state.showModal) {
          modalStore.commit('ocultarBitacora');
        } else {
          modalStore.commit('mostrarBitacora');
        }
      }
    },
    mostrarModalFull: {
      get() {
        // return modalStore.state.showModalFull;
        // eslint-disable-next-line
        return modalStore.state.showModalFull && modalStore.state.febosId == this.documento.febosId;
      },
      set() {
        if (modalStore.state.showModalFull) {
          modalStore.commit('ocultarBitacoraFull');
        } else {
          modalStore.commit('mostrarBitacoraFull');
        }
      }
    },
    getTitulo: {
      get() {
        return modalStore.state.tituloModal;
      }
    },
    getCompomente: {
      get() {
        return modalStore.state.componente;
      }
    }
  },
  mounted() {
    // console.log(this.acciones);
  },
  methods: {
    cargarComponenteAccion(accion) {
      if (!this.componentes[accion]) {
        this.componentes[accion] = () => import(`@/febos/chile/dte/componentes/acciones/Accion${accion}.vue`);
      }
      return this.componentes[accion];
    },

  }
};
</script>

<style scoped>
::v-deep .fullscreen {
  height: 90vh;
}

.menu-accion {
  vertical-align: middle;
  width: 250px !important;
}

.icono, .accion {
  vertical-align: top;
  display: inline-flex;
}

.menu-accion .icono {
  margin-right: 5px;
}
</style>
